<!-- <template>
	<div class="module_container full">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @cell-click="cellClick"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="moduleName+'_list'">

		</vxe-grid>

		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />

	</div>
</template>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'

	export default {
		extends: listBase,
		name: 'controllIndex',
		props: {

		},
		data() {
			return {
				componenttype: 'system',
				moduleName: 'formcontroll',
				windowName: '操作管理',
				previewData: {
					name: '',
					rule: null,
					show: false,
					controll: null,
					controllname: ''
				},
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 100,
					pageSizes: [100, 200, 500],
				},
				getflow:[]
			}
		},
		watch: {

		},
		created() {
			this.$api.form.get(this.foreingKey.formid, {
				controlltype: 2
			}).then((res) => {
				this.targetRule = res.rule
				this.targetTitle = res.title
			})
			this.$api.flow.list({
				formid: this.foreingKey.formid,
				currentPage: -1
			}).then((res) => {
				this.flow = res.list
			})
		},
		mounted() {
			
		},
		computed: {

		},

		methods: {
			beforeRender(res){
				let componenttype = ['','系统预置','用户定义']
				let controlltype = ['','新增','更新','预览']
				res.list.forEach((item)=>{
					item.componenttype = componenttype[item.componenttype]
					item.controlltype = controlltype[item.controlltype]
				})
			},
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field=='flowid'){
						item.slots = {
							default: ({row}) => {	
								if(row.flowid == 0){
									return '非流程'
								}else{
									let existflow = this.flow.find((item)=>{
										return item.id == row.flowid
									})
									if(existflow){
										return existflow.name + '【'+(existflow.type=='main'?'主流程':'子流程')+'】'
									}else{
										return ''
									}
								}
							}
						}
					}
				})
				
			},
			preview(row) {
				import('@_system/components/forms/form/preview.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'form',
						show: true,
						controlltype: 1,
						extra: {
							rule: this.targetRule,
							title: this.targetTitle,
							controll: row.controll,
							controllname: row.name
						}
					}
				})
			},
			add() {
				import('@_system/components/forms/form/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'formcontroll',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey: {
							formid: this.foreingKey.formid,
							flow:this.flow
						},
						extra: {
							targetRule: this.targetRule
						}
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/form/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'formcontroll',
						id: row.id,
						controlltype: 2,
						show: true,
						foreingKey: {
							formid: this.foreingKey.formid,
							flow:this.flow
						},
						extra: {
							targetRule: this.targetRule
						}
					}
				})
			},
			auth(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.id,
						show: true,
						extra: {
							type: 'formcontroll',
						}
					}
				})
			},		
			copy(row) {
				import('@_system/components/forms/form/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'formcontroll',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey: {
							formid: this.foreingKey.formid,
							flow:this.flow
						},
						extra: {
							targetRule: this.targetRule,
							copyid: row.id
						}
					}
				})
				
			},	
			cellClick({
				row,
				column
			}) {
				if (column.field != '') {
					this.preview(row)
				}
			}
		},
		components: {
			
		}
	}
</script>
